<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  name: string;
  size: number;
}>();

defineEmits<{ (e: 'remove'): void }>();

const formattedSize = computed(() => {
  const bytes = props.size;
  if (!bytes || bytes <= 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${Math.round(kb)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
});
</script>

<template>
  <div class="flex items-center gap-3 py-2">
    <div
      data-test="resume-icon"
      class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-md bg-highlight-50 text-highlight-700"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 2v6h6"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="min-w-0 flex-1">
      <p class="truncate text-sm font-bold text-shade-900">{{ name }}</p>
      <p v-if="formattedSize" class="truncate text-xs text-shade-800">{{ formattedSize }}</p>
    </div>
    <button
      data-test="remove-resume"
      type="button"
      class="flex-shrink-0 p-1 text-shade-700 hover:text-shade-900"
      @click="$emit('remove')"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 6h18M8 6V4a1 1 0 011-1h6a1 1 0 011 1v2m2 0v14a1 1 0 01-1 1H7a1 1 0 01-1-1V6h12z"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</template>
